import Vue from "vue";
import vuetify from "../vuetify";
import globalVariables from "../../../spa/utils/globalVariables";
import "../../../spa/scss/spa_main.scss";
import "../../../resources/scss/v2/singleApp.scss";
import publicRoutes from "@/router/publicRoutes";
import contractTemplatesListLT from "~@/lang/apps/contractTemplatesList/lt.json";
import i18nBuilder from "~@/js/translationsBuilder";
import routerBuilder from "~@/js/routerBuilder";

Vue.prototype.$global = globalVariables;

const routes = [
    {
        path: "/:locale([a-z]{2})",
        component: () => import(/* webpackChunkName: "ContractTemplatesListLocaleView" */ "../../../spa/views/Locale.vue"),
        children: [
            ...publicRoutes,
        ]
    }
];

const messages = {
    lt: contractTemplatesListLT,
    en: {}
}

new Vue({
    el: "#contract-templates-list",
    vuetify,
    i18n: i18nBuilder({
        messages
    }),
    router: routerBuilder(routes),
    components: {
        VueApp: () => import(/* webpackChunkName: "VueApp" */ "./views/VueApp.vue"),
        ContractTemplatesList: () =>
            import(
                /* webpackChunkName: "ContractTemplatesList" */ "../../../spa/views/Contracts/ContractTemplatesList/ContractTemplatesList.vue"
            ),
    },
});
